
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.6258 15.5239C22.9561 22.2203 16.173 26.2957 9.47502 24.6258C2.77977 22.9562 -1.29605 16.1735 0.374439 9.47748C2.04337 2.78028 8.82651 -1.29546 15.5225 0.374057C22.2201 2.04357 26.2956 8.8271 24.6258 15.5239Z","fill":"#F7931A"}}),_c('path',{attrs:{"d":"M18.0106 10.7191C18.2595 9.05581 16.993 8.16168 15.2611 7.5652L15.8229 5.3121L14.4513 4.97031L13.9043 7.16403C13.5438 7.07419 13.1734 6.98943 12.8054 6.90544L13.3562 4.69726L11.9854 4.35547L11.4232 6.60779C11.1248 6.53982 10.8318 6.47263 10.5474 6.40193L10.5489 6.3949L8.65731 5.92264L8.29242 7.38747C8.29242 7.38747 9.31011 7.62067 9.28862 7.63512C9.84415 7.77379 9.94455 8.14137 9.92775 8.43277L9.28784 10.9995C9.32613 11.0093 9.37574 11.0234 9.43043 11.0452C9.38473 11.0339 9.33589 11.0214 9.2855 11.0093L8.38853 14.605C8.32055 14.7737 8.14827 15.0268 7.75994 14.9308C7.77362 14.9507 6.76296 14.6819 6.76296 14.6819L6.08203 16.2518L7.86699 16.6968C8.19905 16.78 8.52448 16.8671 8.84483 16.9491L8.27719 19.228L9.64725 19.5698L10.2094 17.3151C10.5837 17.4167 10.947 17.5104 11.3025 17.5987L10.7423 19.8428L12.1139 20.1846L12.6816 17.91C15.0205 18.3526 16.7793 18.1741 17.5196 16.0589C18.1161 14.3558 17.4899 13.3733 16.2593 12.7327C17.1555 12.5261 17.8305 11.9366 18.0106 10.7191ZM14.8767 15.1132C14.4528 16.8163 11.585 15.8956 10.6552 15.6647L11.4084 12.6456C12.3382 12.8776 15.3197 13.337 14.8767 15.1132ZM15.301 10.6945C14.9142 12.2437 12.5272 11.4566 11.7529 11.2636L12.4358 8.52535C13.2101 8.71831 15.7038 9.07847 15.301 10.6945Z","fill":"white"}})])
          )
        }
      }
    